<template>
  <b-container class="main-container">
    <div class="pdf-template">
      <!-- Logo -->
      <div class="header-logo">
        <b-skeleton-img no-aspect width="110" height="60" class="logo-skeleton" />
      </div>

      <!-- Título + Subtítulo -->
      <div class="header-text">
        <b-skeleton width="40%" height="24px" class="mb-2" />
        <b-skeleton width="30%" height="16px" />
      </div>

      <main>
        <!-- Disclaimer -->
        <div class="disclaimer">
          <b-skeleton width="30%" height="16px" />
        </div>

        <!-- CLIENT DATA -->
        <div class="section-title">
          <b-skeleton width="180px" height="16px" />
        </div>
        <div class="info-table-skeleton">
          <div class="row" v-for="n in 3" :key="'client-row-'+n">
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
          </div>
        </div>

        <!-- CREDITOR DATA -->
        <div class="section-title">
          <b-skeleton width="190px" height="16px" />
        </div>
        <div class="info-table-skeleton">
          <div class="row" v-for="n in 3" :key="'creditor-row-'+n">
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
          </div>
        </div>

        <!-- TO A.M.G. DEBT SOLUTION -->
        <div class="section-title">
          <b-skeleton width="250px" height="16px" />
        </div>
        <div class="info-table-skeleton">
          <div class="row" v-for="n in 2" :key="'amg-row-'+n">
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
          </div>
        </div>

        <!-- NEGOTIATOR -->
        <div class="section-title">
          <b-skeleton width="140px" height="16px" />
        </div>
        <div class="info-table-skeleton">
          <div class="row" v-for="n in 2" :key="'negotiator-row-'+n">
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
            <div class="cell">
              <b-skeleton width="55%" height="12px" class="mb-1" />
              <b-skeleton width="90%" height="16px" />
            </div>
          </div>
        </div>

        <!-- Notas finales -->
        <div class="final-note">
          <b-skeleton width="30%" height="16px" />
        </div>
        <div class="final-note-2">
          <b-skeleton width="60%" height="14px" />
        </div>

        <!-- Firmas -->
        <div class="signatures">
          <label><b-skeleton width="120px" height="12px" /></label>

          <label><b-skeleton width="150px" height="12px" /></label>
        </div>
      </main>
    </div>

    <!-- Botón aceptar -->
    <div class="btn-accept">
      <b-skeleton type="button" :width="buttonWidth" height="38px" />
    </div>
  </b-container>
</template>

<script>
import { BSkeleton, BSkeletonImg } from "bootstrap-vue";

export default {
  name: "ActionAcceptanceLetterSkeleton",
  components: {
    "b-skeleton": BSkeleton,
    "b-skeleton-img": BSkeletonImg,
  },
  props: {
    buttonWidth: {
      type: String,
      default: "50%",
    },
  },
};
</script>

<style scoped>
.main-container {
  padding: 0 0 10px;
}

.pdf-template {
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  max-width: 816px;
  margin: 24px auto;
  padding: 30px 40px;
  background: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
}

/* Botón */
.btn-accept {
  display: flex;
  justify-content: center;
  margin: 20px 0 10px;
}
.btn-accept > * {
  width: 50%;
  max-width: 420px;
}

/* Header */
.header-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  position: relative;
}
.logo-skeleton {
  position: absolute;
  left: 0;
}

.header-text {
  text-align: center;
}
.disclaimer {
  font-size: clamp(10px, 2.6vw, 12px);
  text-align: center;
  color: #231f20;
  margin: 8px 0 12px;
}

.section-title {
  margin: 18px 0 6px;
  display: flex;
  justify-content: center;
}

/* Tabla (simulada) */
.info-table-skeleton {
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
}
.info-table-skeleton .row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  padding: 6px 0;
  border-bottom: 1px dashed #f1f3f5;
}
.info-table-skeleton .row:last-child {
  border-bottom: 0;
}
.info-table-skeleton .cell {
  display: flex;
  flex-direction: column;
}

/* Notas finales */
.final-note,
.final-note-2 {
  font-size: clamp(10px, 2.6vw, 12px);
  text-align: center;
  color: #231f20;
  padding: 4px 16px;
}

/* Firmas */
.signatures {
  margin-top: 50px;
  font-size: clamp(10px, 2.6vw, 12px);
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.signatures label {
  color: #231f20;
  font-weight: bold;
}
.signature-line,
.signature-line.small {
  border-bottom: 1px solid #000;
  width: 30%;
  height: 1em;
}

/* Responsivo */
@media (max-width: 992px) {
  .signatures {
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 12px;
    row-gap: 10px;
    align-items: center;
    margin-top: 20px;
  }
  .signatures label {
    text-align: left;
    padding: 0 8px 0 0;
  }
  .signature-line,
  .signature-line.small {
    width: 100%;
    min-width: 0;
  }
}

@media (min-width: 768px) {
  .pdf-template {
    padding: 40px 30px;
    margin: 40px auto;
  }
  .btn-accept > * {
    width: 25%;
    max-width: none;
  }
}

@media (max-width: 576px) {
  .header-logo {
    margin: 16px 0 8px;
  }
  .logo-skeleton {
    position: static;
  }
}
</style>
